<template>
  <div>
    <base-header class="pb-6 pb-8 pt-8 pt-md-5">
      <!-- Card stats -->
    </base-header>

    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col">
          <div class="col-xl-8 order-xl-1">
            <card shadow>
              <template #header>
                <div class="border-0">
                  <div class="row align-items-center">
                    <div class="col-8 text-start">
                      <h5 v-if="!isUpdate" class="mb-0">{{ $t("Add new System User") }}</h5>
                      <h5 v-else class="mb-0">{{ $t("Update System User") }}</h5>
                    </div>
<!--                    <div class="col-4 text-end btn-sm">-->
<!--                      <base-button @click="deleteUser" size="sm" type="danger" >Remove</base-button>-->
<!--                    </div>-->
                  </div>
                </div>
              </template>
              <form>
                <div class="ps-lg-4">
                  <div class="row">
                    <div v-if="!isUpdate" class="col-lg-6">
<div class="form-group has-label">
                        <label class="form-control-label float-start">{{ $t("Phone number") }}</label>
                        <base-input
                            v-model="model.phoneNumber"
                            type="number"
                            form-classes="input-group-alternative mb-0 phone-input"
                            style="display: flex;border-radius: 0;"
                            :placeholder="$t('Phone number')"
                            :error="v$.model.phoneNumber.$errors.map( err => { return err.$message })[0]"
                        >
                          <template #addonLeft>
                            <select v-model="model.phoneNumberCode" class="form-control form-control-alternative" style="padding: 0;height: 23px;border: none !important;">
                              <option v-for="country in countryCodes" :key="country.code" :value="country.code">
{{ isWindows ? '' : isoCountryCodeToFlagEmoji(country.iso)
                                }} {{ country.iso }} {{ country.code }}
</option>
                            </select>
                          </template>
                          <template #infoBlock>
                            <span class="text-sm text-muted w-100">{{ $t("Will be used to send verification code for login.") }}</span>
                          </template>
                        </base-input>
                      </div>
                    </div>
                    <div v-if="!isUpdate" class="col-lg-6">
                      <base-input
                          v-model="model.email"
                          alternative=""
                          :label="$t('Email')"
                          :placeholder="$t('Email')"
                          input-classes="form-control-alternative"
                      />
                    </div>
                    <div class="col-lg-6 text-start">
                      <div class="form-group has-label">
                      <label class="form-control-label ">{{ $t("Preferred language") }} </label>
                      <multiselect
                          v-model="model.contactLanguage"
                          :options="['en','el']"
                          :placeholder="$t('Select language')"
                          :show-labels="false"
                          required
                          class=""
                      >
                        <template #singleLabel="{ option }">{{ $t(option) }}</template>
                        <template #option="props">
                          {{ $t(props.option) }}
                        </template>
                      </multiselect>
</div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-6">
                      <base-input
                          v-model="model.firstName"
                          alternative=""
                          :label="$t('First name')"
                          :placeholder="$t('First name')"
                          input-classes="form-control-alternative"
                      />
                    </div>
                    <div class="col-lg-6">
                      <base-input
                          v-model="model.lastName"
                          alternative=""
                          :label="$t('Last name')"
                          :placeholder="$t('Last name')"
                          input-classes="form-control-alternative"
                      />
                    </div>
<!--                    <div class="col-lg-6">-->
<!--                      <div class="form-group has-label">-->
<!--                        <label class="form-control-label">{{ $t("Receive request updates") }} </label>-->
<!--                        <multiselect-->
<!--                            v-model="model.receiveRequestUpdates"-->
<!--                            :options="['true', 'false']"-->
<!--                            :preselect-first="true"-->
<!--                            :show-labels="false"-->
<!--                            tagPosition="bottom"-->
<!--                            required-->
<!--                            class=""-->
<!--                        >-->
<!--                          <template v-slot:singleLabel="{ option }" >{{ $t(option.toString()) }}</template>-->
<!--                          <template #option="props" >-->
<!--                            {{ $t(props.option.toString()) }}-->
<!--                          </template>-->
<!--                        </multiselect>-->
<!--                      </div>-->
<!--                    </div>-->
                    <div class="col-lg-6">
                      <div class="form-group has-label">
                      <label class="form-control-label">{{ $t("Status") }} </label>
                      <multiselect
                          v-model="model.status"
                          :options="['active', 'disabled']"
                          :placeholder="$t('Select status')"
                          :show-labels="false"
                          required
                          class=""
                      >
                        <template #singleLabel="{ option }">{{ $t(option) }}</template>
</multiselect>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 text-end">
                  <base-button v-if="!isUpdate" class="me-2" outline type="info" @click="clearForm">{{ $t("Reset") }}</base-button>
                  <submit-button :alert-message="errorMessage" :state="loadingProcess" @clicked="submitUser">{{ $t(isUpdate ? 'Update' : 'Submit') }}</submit-button>
                </div>
              </form>
            </card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {isoCountryCodeToFlagEmoji, isWindows} from "@/helpers/common"

const isValidPhone = (param) => helpers.withParams(
    { type: "isValidPhone", value: param }, (value) => {

      if (value == null || value === ""){
        return true
      }
      return isValidNumber(param+value)
    })
import FirebaseFunctionsHelper from "@/helpers/firebaseFunctionsHelper"
import BaseButton from "@/components/BaseButton"
import useVuelidate from "@vuelidate/core"
import {email, helpers, required} from "@vuelidate/validators"
import {getCountries, getCountryCallingCode, isValidNumber, parsePhoneNumber} from "libphonenumber-js"
export default {
  name: "newSystemUser",
  components: {BaseButton},
  setup: () => ({ v$: useVuelidate() }),
  data() {
    return {
      isUpdate: false,
      errorMessage: "",
      countryCodes: [],
      loadingProcess: "",
      loadingMessage: "",
      dbUser: null,
      model: {
        contactLanguage: "en",
        email: "",
        password: "",
        firstName: "",
        lastName: "",
        // receiveRequestUpdates: "true",
        phoneNumberCode: "+357",
        phoneNumber: "",
        status: "active"
      },
    }
  },
  validations () {
    return {
      model: {
        email: {
          email: email,
          required: helpers.withMessage(this.$t("Value is required"), required)
        },
        phoneNumber: {
          required,
          validated: helpers.withMessage(this.$t("Must be valid phone number."), isValidPhone(this.model.phoneNumberCode))
        },
      }
    }
  },
  async mounted() {
    if (this.$route.params.hasOwnProperty("id")) {
      this.isUpdate = true
      await this.getSystemUser()
    }

    let countries = ["CY", "GB", "GR"]

    countries.forEach( country => {
      let code = getCountryCallingCode(country)
      this.countryCodes.push({code: "+" + code, text: country + " +" + code, iso: country})
    })
  },
  methods: {
    isWindows,
    isoCountryCodeToFlagEmoji,
    async getSystemUser() {
      await this.$store.dispatch("fetchSystemUser", this.$route.params.id).then( user => {
        this.dbUser = JSON.parse(JSON.stringify(user))
        this.model = user
        this.dbmMobilePhone = user.phoneNumber
        let phoneDetails = parsePhoneNumber(user.phoneNumber)
        this.model.phoneNumber = phoneDetails.nationalNumber
        this.model.phoneNumberCode = "+"+phoneDetails.countryCallingCode
        // this.model.receiveRequestUpdates = this.model.receiveRequestUpdates.toString()
      }).catch( error => {
        console.log(error)
      })
    },
    async submitUser() {
      let self = this

      this.v$.$touch()

      if (this.v$.model.$invalid) {
        console.log(this.v$.$errors)
        return
      }

      let payload = {
        firstName: this.model.firstName,
        lastName: this.model.lastName,
        status: this.model.status,
        contactLanguage: this.model.contactLanguage,
        // receiveRequestUpdates: this.model.receiveRequestUpdates,
        email: this.model.email
      }

      if (this.isUpdate && this.dbUser !== null){
        payload["id"] = this.$route.params.id

      } else {
        payload["phoneNumber"] = this.model.phoneNumberCode + this.model.phoneNumber
      }

console.log("this.isUpdate", this.isUpdate)
console.log("payload", payload)

      this.loadingProcess = "processing"
      FirebaseFunctionsHelper.callFunction(
          this.isUpdate ? "system-updateUser" : "system-createUser",
        payload
      )
        .then((result) => {
          // eslint-disable-next-line no-prototype-builtins
          if (result != null && result.hasOwnProperty("message")) {
            self.loadingProcess = "failed"
            self.errorMessage = result.message
            return
          }
          this.loadingProcess = "done"
          this.$router.push({ path: "/systemUsers" })
        })
        .catch((error) => {
          self.loadingProcess = "failed"
          self.errorMessage = error.message
          console.log("submitUser error", error)
        })

      // setTimeout(() => {
      //   this.loadingProcess = "failed";
      //   this.loadingMessage = "There was an error.";
      //   //Add Tokens
      // }, 2000);
    },
    clearForm() {
      this.loadingProcess = ""
      if (this.dbUser){
        this.model = this.dbUser
      } else {
        this.model = {
          email: "",
          firstName: "",
          lastName: "",
          status: ""
        }
      }
    },
  },
}
</script>
<style scoped>
.form-group.has-label {
  padding-top: 0.5rem !important;
}
</style>
